import { render, staticRenderFns } from "./ModifyCustomer.vue?vue&type=template&id=52c3234a&scoped=true"
import script from "./ModifyCustomer.vue?vue&type=script&lang=js"
export * from "./ModifyCustomer.vue?vue&type=script&lang=js"
import style0 from "./ModifyCustomer.vue?vue&type=style&index=0&id=52c3234a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c3234a",
  null
  
)

export default component.exports